import * as React from 'react';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Box } from '@mui/material';

import PaginatedListWrapper from '../../../../../components/PagedFilterList';
import {
  selectIsLoadingPendingWorkerPlacements,
  selectPendingWorkerPlacements,
} from '../../../../../store/selectors/userListSelector';
import { FILTERS } from '../../../UsersConstants';
import { getPendingWorkerPlacements } from '../../../usersListReducer';

import RowCards from './RowCards';

const LIMIT = 5;

const PendingWorkerPlacements = ({ user }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(selectIsLoadingPendingWorkerPlacements);
  const pendingWorkerPlacements = useSelector(selectPendingWorkerPlacements);

  const [page, setPage] = useState(0);
  useEffect(() => {
    dispatch(
      getPendingWorkerPlacements({
        filters: [
          FILTERS.UPCOMING,
          {
            value: user?.id,
            field: 'candidate',
            operation: 'equalsID',
          },
          {
            field: 'state.status',
            value: ['pendingEmployeeAcceptance', 'pendingEmployerApproval'],
            operation: 'includedIn',
          },
        ],
        page,
        limit: LIMIT,
        sortBy: [{ field: 'start', descending: false }],
      })
    );
  }, [dispatch, page, user.id]);

  const handleOnPageChange = (newPage) => {
    setPage(newPage);
  };

  const title = LanguageConverter('userDetail.pendingWorkerPlacements.title');

  return (
    <Box>
      <PaginatedListWrapper
        isLoading={isLoading}
        content={<RowCards placements={pendingWorkerPlacements?.documents} />}
        limit={LIMIT}
        title={title}
        currentPageNum={page}
        totalListCount={pendingWorkerPlacements?.count}
        handleOnPageChange={handleOnPageChange}
      />
    </Box>
  );
};
PendingWorkerPlacements.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
  }),
};
export default PendingWorkerPlacements;
